import { ref, watch, computed } from "vue-demi";

// Pinia
import { defineStore } from "pinia";
import { usePageStore } from "@/stores/pageHeader";

// Utils
import { postData } from "@utils";

// Plugin
import { useToast } from "vue-toastification/composition";

export const usePaymentTrackingStore = defineStore("paymentTracking", () => {
  // Initial
  const pageStore = usePageStore();
  const toast = useToast();
  const cardDisabled = ref(true);
  const isError = ref(false);

  // Table
  const tableLoading = ref(true);
  const tableEmptySearch = ref(3);
  const tableSearch_1 = ref("");
  const tableSearch_2 = ref("");
  const tableSearch_3 = ref("");
  const tableItems = ref([]);
  const tableColumns = computed(() => [
    {
      text: "Belge Tipi",
      value: "FINDOCTYPE",
      sortable: false,
      width: "90px",
      filter: (f) =>
        tableSearch_1.value === null
          ? ((tableSearch_1.value = ""), f)
          : f.toLowerCase().includes(tableSearch_1.value.toLowerCase()),
    },
    {
      text: "Belge No",
      value: "FINDOCNUM",
      sortable: false,
      width: "100px",
      filter: (f) =>
        tableSearch_2.value === null
          ? ((tableSearch_2.value = ""), f)
          : f.toLowerCase().includes(tableSearch_2.value.toLowerCase()),
    },
    {
      text: "Cari Unvan",
      value: "ACCNAME",
      sortable: false,
      filter: (f) =>
        tableSearch_3.value === null
          ? ((tableSearch_3.value = ""), f)
          : f.toLowerCase().includes(tableSearch_3.value.toLowerCase()),
    },
    {
      text: "Vade Tarihi",
      value: "DUEDATE",
      sortable: false,
      width: "150px",
    },
    {
      text: "Ödeme Tarihi",
      value: "POSTDATE",
      sortable: false,
      width: "150px",
    },
    {
      text: "Tutar (TL)",
      value: "DCREDIT",
      align: "right",
      sortable: false,
      width: "150px",
    },
  ]);

  const tableFetch = async ({ start, end }) => {
    tableItems.value = [];
    isError.value = false;
    tableLoading.value = true;
    cardDisabled.value = true;
    try {
      const data = await postData({
        method: "getCustFinPayment",
        "search[startDate]": start,
        "search[endDate]": end,
      });

      if (!data.detail) {
        throw new Error("Kayıt Yok");
      }
      tableItems.value = data.detail;
      pageStore.downloadData = tableItems.value;
    } catch (e) {
      // API hataya girdi
      isError.value = true;
      toast.error(`${e}`);
    } finally {
      cardDisabled.value = false;
      tableLoading.value = false;
    }
  };

  return {
    tableItems,
    tableColumns,
    tableLoading,
    tableSearch_1,
    tableSearch_2,
    tableSearch_3,
    tableEmptySearch,
    tableFetch,
    cardDisabled,
    isError,
  };
});
